import React from "react";

const DesktopPreLogin = ({ selectedTab, handleJoinUs, handleChangeTab }) => (
  <div className="tab-body hide-xs">
    <div className="container">
      <ul className="tab-list">
        <li onClick={() => handleChangeTab("howItWorks")}>
          <a
            href="#how-it-works"
            className={(selectedTab === "howItWorks" && "active") || ""}
          >
            How it Works?
          </a>
        </li>
        <li onClick={() => handleChangeTab("loveLocal")}>
          <a
            href="#our-local-e"
            className={(selectedTab === "loveLocal" && "active") || ""}
          >
            Our Local E Story
          </a>
        </li>
        <li onClick={() => handleChangeTab("joinUs")}>
          <a
            href="#join-us"
            className={(selectedTab === "joinUs" && "active") || ""}
          >
            Join the Local E revolution!
          </a>
        </li>
      </ul>
      <div id="how-it-works" />
      <div className="tab1 how-it-works">
        <h4>How it Works</h4>

        <div className="d-flex justify-content-around mt-50px">
          <div className="section1">
            <div className="prelogin-section-div">
              <img src="/png/prelogin1.png" />
            </div>

            <p>
              Order food online for delivery<br/>or collection from the best<br/>local independent restaurants.
            </p>
          </div>

          <div className="section2">
            <div className="prelogin-section-div">
              <img src="/png/prelogin2.png" />
            </div>
            <p>
              Earn Local eCoin rewards <br />with every order as a <br />thank you for supporting local.
            </p>
          </div>

          <div className="section3">
            <div className="prelogin-section-div">
              <img src="/png/prelogin3.png" />
            </div>

            <p>
              Save and spend your <br />Local eCoins on your favourite <br />takeaways just like cash.
            </p>
          </div>
        </div>

        <h5>Order. Eat. Reward. Repeat.</h5>
      </div>
    </div>
    <div id="our-local-e" />
    <div className="tab-info our-local">
      <div className="container d-flex justify-content-between align-items-center">
        <div className="img">
          <h4>Our Local E Story</h4>
          <img src="/png/story.png" />
        </div>
        <div>
          <p>
            It started with an idea… as all ideas do.
            <br />
            Funny that. Click below to find out more.
          </p>

          <a href="/about-us" className="btn btn-blue">
            More about us
          </a>
        </div>
      </div>
    </div>
    <div id="join-us" />
    <div className="tab-info join-us">
      <div className="container">
        <h4>Join Our Local E Revolution!</h4>
        <div className="d-flex justify-content-between align-items-center">
          <div className="img">
            <img src="/png/join.png" />
          </div>
          <div>
            <p>
              Is your business looking for lower commission rates and a platform{" "}
              <br />
              that champions local independent restaurants and takeaways?
              <br />
              Then you’ve come to the right place. Click below to find out more
              and
              <br />
              join the revolution.
            </p>
            <a
              href="javascript: void(0)"
              onClick={() => handleJoinUs({ status: "open" })}
              className="btn btn-blue"
            >
              Join us
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default DesktopPreLogin;
